// REST client (= DDSIM-11)。
// fetch ベースで `/healthz` を叩く。
// baseUrl の末尾 `/` 有無は normalize し、 200 以外は ApiError で reject する。
//
// Note: getDecks / getDeck は DDSIM-18 で撤去 (= サンプルデッキによるローカル参照に移行)。

export class ApiError extends Error {
  readonly status: number;
  readonly url: string;

  constructor(message: string, status: number, url: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.url = url;
  }
}

/** `baseUrl` の末尾 `/` を取り除いた canonical 形式を返す。 */
function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.replace(/\/+$/, "");
}

function joinUrl(baseUrl: string, path: string): string {
  const base = normalizeBaseUrl(baseUrl);
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return `${base}${suffix}`;
}

/**
 * `GET /healthz` を叩く。 200 で resolve、 それ以外で {@link ApiError} reject。
 */
export async function getHealthz(baseUrl: string): Promise<void> {
  const url = joinUrl(baseUrl, "/healthz");
  const res = await fetch(url, { method: "GET" });
  if (!res.ok) {
    throw new ApiError(
      `GET ${url} failed: ${res.status} ${res.statusText}`,
      res.status,
      url,
    );
  }
}
